import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { SepaSchemeEnum, SepaSequenceEnum } from '../../enums';
import { PartnerModel } from '../../../partners/corporate/models/partner.model';
import { PrivatePartnerModel } from '../../../partners/private/models/partner.model';
import { FormInputChangedModel } from '../../models';


@Component({
  selector: 'rnpl-partner-sepa-settings',
  templateUrl: './partner-sepa-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartnerSepaSettingsComponent implements OnChanges {

  public form: FormGroup;

  public maskPatterns = {
    N: { pattern: new RegExp('[A-Za-z0-9\\/\\-?:().,\' ]') }
  };

  public sequencesList = [
    {value: SepaSequenceEnum.FIRST, label: 'SEPA_EXPORT.FIRST_PAYMENT'},
    {value: SepaSequenceEnum.RECURRING, label: 'SEPA_EXPORT.RECURRING_PAYMENT'},
    {value: SepaSequenceEnum.ONE_TIME, label: 'SEPA_EXPORT.ONE_TIME_PAYMENT'},
  ];

  public schemeList = [
    {value: SepaSchemeEnum.CORE, label: 'CORE'},
    {value: SepaSchemeEnum.B2B, label: 'B2B'},
  ];

  @Input() partner: PartnerModel|PrivatePartnerModel;
  @Input() isReadonly: boolean = false;
  @Input() showSchemeControl: boolean = false;

  @Output() fieldChanged: EventEmitter<FormInputChangedModel> = new EventEmitter<FormInputChangedModel>();

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.hasOwnProperty('partner')) {
        this.form.patchValue(this.partner);
      }

      if (changes.hasOwnProperty('isReadonly')) {
        if (this.isReadonly) {
          this.form.disable();
        } else {
          this.form.enable();
        }
      }
    }
  }

  public initForm(): void  {
    this.form = this.fb.group({
      sepaEnabled: [],
      sequenceType: [],
      signatureDate: [],
      mandatId: [],
      scheme: [],
    });
  }

  public updateField(fieldValue: any, fieldName: string): void {
    this.fieldChanged.emit({fieldName, fieldValue});
  }

  get sepaEnabledControl(): FormControl { return this.form.get('sepaEnabled') as FormControl }
  get sequenceTypeControl(): FormControl { return this.form.get('sequenceType') as FormControl }
  get signatureDateControl(): FormControl { return this.form.get('signatureDate') as FormControl }
  get mandatIdControl(): FormControl { return this.form.get('mandatId') as FormControl }
  get schemeControl(): FormControl { return this.form.get('scheme') as FormControl }

}
